<template>
  <div class="home">
    <div class="homePage">
      <div class="home-left">
        <div class="left-i">
          <img
            src="~@/assets/icon-home-01.png"
            alt=""
          >
          <p>{{ userInfo.customerCount ? userInfo.customerCount : 0 }}</p>

          <div>客户数量</div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-05.png"
            alt=""
          >
          <p>{{ userInfo.deviceCount ? userInfo.deviceCount : 0 }}</p>

          <div>设备总数 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.faultDeviceCount ? userInfo.faultDeviceCount : 0 }}</p>

          <div>故障 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.allDevNum ? userInfo.allDevNum : 0 }}</p>

          <div>总设备数 </div>
        </div>

        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.offlineDeviceCount ? userInfo.offlineDeviceCount : 0 }}</p>

          <div>离线数量 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.offlineDeviceCount ? userInfo.offlineDeviceCount : 0 }}</p>

          <div>离线数量 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.onlineDeviceCount ? userInfo.onlineDeviceCount : 0 }}</p>

          <div>在线数量 </div>
        </div>

        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.pipelineCount ? userInfo.pipelineCount : 0 }}</p>

          <div>管线数量 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.normalProtection ? userInfo.normalProtection : 0 }}</p>

          <div>正常保护 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.overProtection ? userInfo.overProtection : 0 }}</p>

          <div>过保护 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.underProtection ? userInfo.underProtection : 0 }}</p>

          <div>欠保护 </div>
        </div>
        <!-- <div class="left-i">
          <img
            src="~@/assets/icon-home-03.png"
            alt=""
          >
          <p v-if="userInfo.thisMonthAmount">{{ userInfo.thisMonthAmount }}</p>
          <p v-else>0</p>

          <div>本月收益</div>
        </div> -->
      </div>

    </div>
    <div class="home_top">
      <a-card :bordered="false">
        <lineChart12 :chartData="chartData"></lineChart12>
      </a-card>
      <!-- <lineChart12 :chartData="chartData"></lineChart12> -->
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { homeStatistics } from '@/api/home'
import lineChart12 from './Charts/lineChart12.vue'
export default {
  name: 'Wel',
  components: {
    lineChart12
  },
  data () {
    return {
      activeNames: ['1', '2', '3', '4'],
      DATA: [],
      chartData: {},
      text: '',
      actor: '',
      count: 0,
      isText: false,
      userInfo: {},
      devList: [],
      role: '',
      userInfo: {}
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  mounted () {

  },
  created () {
    console.log(12121212);
    this.getAddress()
  },
  methods: {
    getAddress () {
      homeStatistics().then(res => {
        console.log(res, '滴滴滴滴滴滴111111============')
        this.userInfo = res.data
        let chart = {
          x: [],
          y: []
        }
        let x = []
        res.data.cityList.forEach(v => {
          console.log(v, '对对对的多多多');
          chart.x.push(v.city)
          chart.y.push(v.deviceCount)
        })
        this.chartData = chart
        console.log(this.chartData, ' this.chartData this.chartData');
      })


    }
  }
}
</script>

<style scoped="scoped" lang="less">
.home {
  width: 100%;
  height: 60%;
  position: relative;

  // background: red;
  // padding: 0 20px;
  // /deep/.amap-box[data-v-f21c6a42] {
  //   margin-left: 0 !important;
  // }
  .homePage {
    // width: 100%;
    // height: 100%;
    // position: absolute;
    // top: 0;
    // left: 0;
    // background: red;
    // padding: 0 20px;
    display: flex;
    justify-content: space-between;

    .home-left {
      width: 100%;
      height: 150px;
      display: flex;
      position: absolute;
      top: 0;
      left: 0;
      // align-items: center;
      justify-content: space-around;

      .left-i {
        margin-top: 20px;
        background: #fff;
        padding: 20px;
        border-radius: 10px;
        width: 120px;
        height: 150px;
        text-align: center;

        img {
          width: 40px;
          height: 40px;
        }

        p {
          font-weight: 700;
        }
      }
    }

    .home-right {
      padding: 10px;
      width: 25%;
      background: #fff;
      height: calc(100vh - 120px);
      overflow-y: auto;
      position: absolute;
      top: 0;
      right: 0;

      .right-t {
        display: flex;
        align-items: center;

        span {
          display: inline-block;
          width: 3px;
          height: 20px;
          border-radius: 3px;
          background: #2295ff;
          margin-right: 20px;
        }

        color: #333;
        font-weight: 700;
        margin-bottom: 20px;
      }

      .right-con {
        display: flex;
        align-items: center;

        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }

        .right-h {
          flex: 1;
          margin-top: 20px;

          .rig-y {
            display: flex;
            align-items: center;

            // cursor: pointer;
            span {
              display: inline-block;
              margin-left: 10px;
            }

            .ant-progress-line {
              width: 60% !important;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
}

.ant-layout-footer {
  height: 0 !important;
  display: none !important;
}

:deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container) {
  margin: 0 !important;
  display: none !important;
}

.home_top {
  margin-top: 330px;
}
</style>
